import PropTypes from "prop-types"
import styles from "./index.module.css"
import { WarningOutlined } from "@ant-design/icons"

const WarningOutlinedWithBg = ({className}) => {
  return <WarningOutlined className={className || styles.warningIcon} />
}

WarningOutlinedWithBg.propTypes = {
  className: PropTypes.string
}
export default WarningOutlinedWithBg
